// Sprint 16 A4: Key Metrics Row — 5 metrics with trend arrows (C10)
import { TrendingUp, TrendingDown, Minus } from "lucide-react";
import type { DashboardMetric } from "@/hooks/use-dashboard-metrics";
import { SkeletonMetricCard } from "@/components/skeleton";

interface KeyMetricsRowProps {
  metrics: DashboardMetric[] | null;
  isLoading: boolean;
}

export function KeyMetricsRow({ metrics, isLoading }: KeyMetricsRowProps) {
  if (isLoading || !metrics) {
    return (
      <div className="density-gap grid grid-cols-2 md:grid-cols-5 gap-4">
        {Array.from({ length: 5 }).map((_, i) => (
          <SkeletonMetricCard key={i} />
        ))}
      </div>
    );
  }

  return (
    <div className="density-gap grid grid-cols-2 md:grid-cols-5 gap-4">
      {metrics.map((m, i) => {
        const TrendIcon = m.trend === "up" ? TrendingUp : m.trend === "down" ? TrendingDown : Minus;
        const trendColor = m.trend === "up" ? "text-[var(--color-success)]" : m.trend === "down" ? "text-[var(--color-destructive)]" : "text-[var(--color-muted-foreground)]";

        return (
          <div key={m.label} className={`data-reveal data-reveal-${Math.min(i + 1, 8)} stagger-item density-card card-hover rounded-lg border border-[var(--color-border)] bg-[var(--color-card)] p-4 shadow-sm`}>
            <div>
              <div className="text-xs text-[var(--color-muted-foreground)] mb-1">{m.label}</div>
              <div className="text-xl font-bold text-[var(--color-foreground)] tabular-nums">{m.value}</div>
            </div>
            <div className={`flex items-center gap-1 mt-1 text-xs ${trendColor}`}>
              <TrendIcon className="h-3 w-3" />
              <span>{m.trendValue}</span>
            </div>
          </div>
        );
      })}
    </div>
  );
}
